import React, { useState } from "react";
import { MenuItem, Select, OutlinedInput, useTheme } from "@mui/material";
import { styled } from "@mui/system";

// Ajouter des styles personnalisés pour le composant Select
const CustomOutlinedInput = styled(OutlinedInput, {
  shouldForwardProp: (prop) => prop !== 'role',
})(({ role }) => {
  const isOnet = role === "onet";
  const isCompass = role === "compass";
  return{
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: isOnet ? '#06305C'  : isCompass ? '#c4ac66' : '',
      borderRadius: 6,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: isOnet ? '#06305C'  : isCompass ? '#c4ac66' : '#F7E900',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: isOnet ? '#06305C'  : isCompass ? '#c4ac66' : '#F7E900',
    },
    '& .MuiOutlinedInput-input': {
      padding: '10.5px 14px',
    },
    '& legend': {
      maxWidth: '0px',
    },
    '& span': {
      display: 'none',
    },
  }
});

const ClientFilter = ({ data, onFilterChange, sx, role }) => {
  const theme = useTheme();
  const isOnet = role === "onet";
  const isCompass = role === "compass";
  const isDark = theme.palette.mode === "dark";
  const [filterClient, setFilterClient] = useState("all");

  const clientNames = [
    ...new Set(data.map((item) => item.content["selected-service"])),
  ];

  const handleFilterChange = (e) => {
    const clientName = e.target.value;
    setFilterClient(clientName);
    onFilterChange(clientName);
  };

  return (
    <Select
      key={`client-filter-${role}`}
      value={filterClient}
      onChange={handleFilterChange}
      input={<CustomOutlinedInput label="Tous les clients" role={role} />}
      sx={{
        height: "40px",
        ...sx,
        '& .MuiOutlinedInput-root': {
          '& fieldset': {
            borderColor: isOnet ? '#06305C' : '#F7E900',
          },
          '&:hover fieldset': {
            borderColor: isOnet ? '#06305C' : '#F7E900',
          },
          '&.Mui-focused fieldset': {
            borderColor: isOnet ? '#06305C' : '#F7E900',
          },
        },
      }}
      MenuProps={{
        PaperProps: {
          sx: {
            backgroundColor: theme.palette.background.paper,
            '& .MuiMenuItem-root': {
              color: theme.palette.text.primary,
              '&:hover': {
                backgroundColor: isOnet
                  ? 'rgba(6, 48, 92, 0.08)'
                  : isCompass
                    ? 'rgba(196, 172, 102, 0.08)'
                    : theme.palette.mode === 'dark'
                      ? 'rgba(255, 255, 255, 0.08)'
                      : 'rgba(247, 233, 0, 0.08)',
              },
              '&.Mui-selected': {
                backgroundColor: isOnet
                  ? 'rgba(6, 48, 92, 0.12)'
                  : isCompass
                    ? 'rgba(196, 172, 102, 0.12)'
                    : 'rgba(247, 233, 0, 0.12)',
                '&:hover': {
                  backgroundColor: isOnet
                    ? 'rgba(6, 48, 92, 0.16)'
                    : isCompass
                      ? 'rgba(196, 172, 102, 0.16)'
                      : theme.palette.mode === 'dark'
                        ? 'rgba(255, 255, 255, 0.12)'
                        : 'rgba(247, 233, 0, 0.16)',
                },
              },
            },
          },
        },
      }}
    >
      <MenuItem
        value="all"
        sx={{
          '&.Mui-selected': {
            backgroundColor: isOnet
              ? 'rgba(6, 48, 92, 0.12) !important'
              : isCompass
                ? 'rgba(196, 172, 102, 0.12) !important'
                : 'rgba(247, 233, 0, 0.12) !important',
          },
          '&.Mui-selected:hover': {
            backgroundColor: isOnet
              ? 'rgba(6, 48, 92, 0.16) !important'
              : isCompass
                ? 'rgba(196, 172, 102, 0.16) !important'
                : isDark
                  ? 'rgba(255, 255, 255, 0.12) !important'
                  : 'rgba(247, 233, 0, 0.16) !important',
          },
        }}
      >
        Tous les clients
      </MenuItem>
      {clientNames.map((clientName) => (
        <MenuItem
          key={clientName}
          value={clientName}
          sx={{
            '&.Mui-selected': {
              backgroundColor: isOnet
                ? 'rgba(6, 48, 92, 0.12) !important'
                : isCompass
                  ? 'rgba(196, 172, 102, 0.12) !important'
                  : 'rgba(247, 233, 0, 0.12) !important',
            },
            '&.Mui-selected:hover': {
              backgroundColor: isOnet
                ? 'rgba(6, 48, 92, 0.16) !important'
                : isCompass
                  ? 'rgba(196, 172, 102, 0.16) !important'
                  : isDark
                    ? 'rgba(255, 255, 255, 0.12) !important'
                    : 'rgba(247, 233, 0, 0.16) !important',
            },
          }}
        >
          {clientName}
        </MenuItem>
      ))}
    </Select>
  );
};

export default ClientFilter;
